import styled from "styled-components";
import { RowFlex } from "@/main/components/shared/styles";
import { Button } from "@mui/material";

export const Container = styled.div``;
export const Header = styled.div`
	display: flex;
	flex-direction: column;
`;

export const RowFlexInfoOrder = styled(RowFlex)`
	@media (max-width: 740px) {
		justify-content: space-between;
	}
`;

export const AreaInfoOrder = styled(RowFlex)`
	width: auto;

	@media (max-width: 740px) {
		flex-direction: column;
		gap: 0;
	}
`;

export const AreaButton = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 1rem;
	margin-left: auto;

	> button {
		padding: 0.4rem 0.8rem;
		min-width: 90px;
	}

	@media (max-width: 740px) {
		flex-direction: column;
		justify-content: space-between;
		margin-left: 0;

		> button {
			width: 100%;
			max-width: 100%;
		}
	}
`;
export const Content = styled.div``;
export const Footer = styled.div`
	padding: 0 1.1rem;
`;

export const ButtonTrigger = styled(Button)`
	&&& {
		background: none;
		border: none;
		min-width: fit-content;
	}
`;

export const DropdownArea = styled.div`
	border: 1px solid;
	padding: 1rem;
	background-color: #ffff;
`;
